import React from 'react';
import PropTypes from 'prop-types';
import SvgImg from '../../components/Svg/SvgImg';

/* eslint-disable max-len */
/* eslint-disable react/self-closing-comp */

const Twitter = ({ width, height }) => (
  <SvgImg
    viewbox="0 0 512 512"
    title="icons / followus / twitter"
    width={width}
    height={height}
  >
    <g id="Symbols" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g id="icons-/-followus-/-twitter">
        <g id="Twitter">
          <path d="M512,256c0,141.4-114.6,256-256,256C114.6,512,0,397.4,0,256C0,114.6,114.6,0,256,0   C397.4,0,512,114.6,512,256z" fill="#1DA1F2" />
          <path d="M358.5,202.9c3.3,73.9-51.8,156.2-149.3,156.2c-29.7,0-57.3-8.7-80.5-23.6   c27.9,3.3,55.7-4.4,77.8-21.7c-23-0.4-42.4-15.6-49.1-36.5c8.2,1.6,16.3,1.1,23.7-0.9c-25.3-5.1-42.7-27.8-42.1-52.2   c7.1,3.9,15.2,6.3,23.8,6.6c-23.4-15.6-30-46.5-16.3-70.1c25.9,31.8,64.6,52.7,108.3,54.9c-7.6-32.9,17.3-64.5,51.2-64.5   c15.1,0,28.7,6.4,38.3,16.6c12-2.4,23.2-6.7,33.4-12.7c-3.9,12.3-12.3,22.6-23.1,29.1c10.6-1.3,20.7-4.1,30.2-8.3   C377.6,186.3,368.7,195.5,358.5,202.9z" fill="#FFFFFF" id="twitter-4-icon_3_" />
        </g>
      </g>
    </g>
  </SvgImg>
);
Twitter.propTypes = {
  width: PropTypes.string,
  height: PropTypes.string,
};
Twitter.defaultProps = {
  width: undefined,
  height: undefined,
};
export default Twitter;
